import { useEffect } from 'react'
import { fetchBenefitQueue } from '../api/application-queue-enrollment-platform-api'
import { useAssignmentQueueByAssignee } from './useApplicationQueueSelector'

export function useBenefitQueue(
  setAssignmentQueue: CallableFunction,
  assignee: string
) {
  // O(1) lookup instead of O(n) find operation
  const assignmentQueue = useAssignmentQueueByAssignee(assignee)

  useEffect(() => {
    let ignore = false

    async function loadBenefitQueue() {
      if (!ignore) {
        const result = await fetchBenefitQueue(assignee)
        setAssignmentQueue(result)
      }
    }

    // Grid counts persist { assignee, count } only. Skip cache unless rows exist.
    if (Array.isArray(assignmentQueue?.data)) {
      setAssignmentQueue(assignmentQueue.data)
    } else {
      loadBenefitQueue().catch((error) => {
        console.error('Error loading assignment queues', error)
      })
    }

    return () => {
      ignore = true
    }
  }, [])
}
